const progressOptions = [{
    id: 1,
    name: '安全文明施工日常巡查',
},{
    id: 2,
    name: '施工完成'
},{
    id: 3,
    name: '工程预算、施工方案等上报工程管理处审核汇总'
},{
    id: 4,
    name: '绿化工程预算、苗木迁移方案等上报绿化办审核；市政施工方案上报市政办审核'
},{
    id: 5,
    name: '根据审核完毕工程预算以及施工方案，通知申请单位签订工程施工合同并传阅'
},{
    id: 6,
    name: '申请单位缴纳工程款或保证金'
},{
    id: 7,
    name: '工程管理处验收施工围挡'
},{
    id: 8,
    name: '行政审批大厅根据缴费发票及围挡验收单下发占用挖掘许可证'
}]
export default progressOptions


// WEBPACK FOOTER //
// ./src/page/maintenance/config/progressOptions.js